import { Component, Input, OnChanges } from '@angular/core';
import { EditorLink, IconType, IoniconsOutline } from '@pt/pt-models';

@Component({
  selector: 'pt-editor-sidebar-link',
  template: `
    <div class="editor-sidebar-link mb-2">
      <div class="title">{{ link?.title | async }}</div>
      <ng-template
        *ngIf="link.enabled; then ACTIVED_LINK; else DISABLED_LINK"
      ></ng-template>

      <ng-template #ACTIVED_LINK>
        <div class="editor-sidebar-link-text">
          <a
            class="active-link text-muted"
            [href]="link.link"
            [target]="link.newTab ? '_blank' : '_self'"
          >
            <div class="d-inline-flex">
              {{ link?.label | async }}
            </div>
            <pt-icon [key]="IconLink" [size]="12"></pt-icon>
          </a>
          <div class="justify-content-end" style="width: 50px;">
            <div *ngIf="link.validated" class="validated">
              <pt-icon
                [imageClass]="'cockade-bg-white'"
                [size]="25"
                [iconType]="SVG"
                [key]="validationSuccessIcon"
                [container]="'body'"
                [ngbTooltip]="'LABELS.VALIDATED' | translate"
              ></pt-icon>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template #DISABLED_LINK>
        <div class="disabled-link">
          {{ link?.label | async }}
          <pt-icon [key]="IconLink" [size]="12"></pt-icon>
        </div>
      </ng-template>
    </div>
  `,
  styles: [
    `
      .editor-sidebar-link-text {
        display: flex;
        flex-direction: row;
        align-items: center;
      }

      .editor-sidebar-link-text * {
        display: inline-flex;
        align-items: center;
      }

      .editor-sidebar-link-text a {
        width: calc(100% - 50px);
        align-items: center;
      }

      .editor-sidebar-link-text .version {
        width: 25px;
        font-size: 13px;
      }

      .editor-sidebar-link-text .validated {
        width: 25px;
        margin-top: -6px;
      }

      .editor-sidebar-link {
        border-bottom: 1px solid #ced4da;
        width: 100%;
        margin-top: 12px;
      }

      .editor-sidebar-link .title {
        margin-bottom: 2px;
        margin-top: 5px;
      }

      .active-link {
        height: 25px;
        font-size: 13px;
        padding: 0;
        line-height: 1;
        border-radius: 0;
        /*font-weight: bold;*/
        color: #000000;
      }

      .disabled-link {
        height: 25px;
        padding: 0;
        line-height: 1;
        border-radius: 0;
        font-weight: bold;
        color: #000000;
        opacity: 0.7;
      }
    `,
  ],
})
export class EditorSidebarLinkComponent implements OnChanges {
  @Input() link: EditorLink;
  public SVG = IconType.SVG;
  public validationSuccessIcon = 'validated.svg';

  IconLink = IoniconsOutline.open;

  ngOnChanges(): void {
    // if (this.link) {
    //   console.log('#######################################');
    //   console.log('LINK ', this.link);
    //   console.log('#######################################');
    // }
  }
}
